import { type Role } from 'components/Permission/permission.types';

export const ROLES_OPTIONS: Role[] = [
  'director',
  'internal-user',
  'external-director',
  'external-superadmin',
  'external-admin',
  'external-user',
];

export type EnvironmentsType = 'development' | 'staging' | 'production';

export const ENVIRONMENTS_OPTIONS: EnvironmentsType[] = [
  'development',
  'staging',
  'production',
];

export const tableColumnWidths = {
  screen: '25%',
  webEnabled: '5%',
  appEnabled: '5%',
  module: '12%',
  displayLabel: '20%',
  allowedRoles: '20%',
  environments: '20%',
  showInSidebar: '10%',
} as const;
